import { Component, Input, OnInit } from '@angular/core';
import { RatePlan } from '@app/types/rate-plan';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { SessionStorage } from '@app/types/session-storage.enum';
import { _ } from '@app/translation-marker';
import { FormControl } from '@angular/forms';
import { AutoRenewService } from '@app/auto-renew/auto-renew.service';
import { Account } from '@app/types/account';
import { Flows } from '@app/auto-renew/auto-renew.type';

@Component({
  selector: 'pp-rate-plan',
  templateUrl: './rate-plan.component.html',
  styleUrls: ['./rate-plan.component.scss'],
})
export class RatePlanComponent implements OnInit {
  @Input() account: Account;
  @Input() set ratePlan(ratePlan: RatePlan) {
    this._ratePlan = ratePlan;
    this.autoRenewControl.setValue(ratePlan.autoRenew, { emitEvent: false });
  }
  get ratePlan(): RatePlan {
    return this._ratePlan;
  }
  _ratePlan: RatePlan;
  currencyDisplay: string;
  isDesktop = true;
  locale = sessionStorage.getItem(SessionStorage.Language);
  chargeTranslationKeys = {
    Annual: _('charge.upfront'),
    Semi_Annual: _('charge.upfront'),
    Month: _('charge.monthly'),
    Quarter: _('charge.quarterly'),
    Eighteen_Months: _('charge.upfront'),
    Specific_Months: _('charge.upfront'),
    Two_Years: _('charge.upfront'),
    Three_Years: _('charge.upfront')
  };
  autoRenewKeys = {
    Enabled: _('auto_renew.enabled'),
    Disabled: _('auto_renew.disabled'),
  };

  isAutoRenewDisabled: boolean;

  public autoRenewControl = new FormControl();

  constructor(private breakpointObserver: BreakpointObserver, private autoRenewService: AutoRenewService) {}

  public handleToggleClick() {
    const autoRenewValue = !this.autoRenewControl.value;
    this.autoRenewService.trigger(
      autoRenewValue,
      this.handleSuccess.bind(this),
      this.handleError.bind(this)
    );
  }

  private handleSuccess(flow: Flows, value: any) {
    switch (flow) {
      case Flows.AUTO_RENEW_UPDATE:
        this.autoRenewControl.reset(!this.autoRenewControl.value);
        break;
      case Flows.CANCELLATION_IN_PROGRESS:
        // EMPTY
        break;
      case Flows.CANCELLATION_REQUEST:
        // EMPTY
        break;
      default:
        // EMPTY
    }
  }

  private handleError() {
    // EMPTY
  }

  ngOnInit() {
    this.autoRenewService.initialize(this.ratePlan, this.account.accountId);
    this.isAutoRenewDisabled = this.autoRenewService.isAutoRenewDisabled;
    this.currencyDisplay = this.ratePlan.currency === 'TRY' ? '' : 'symbol';
    this.breakpointObserver
      .observe([Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])
      .subscribe((result) => {
        this.isDesktop = result.matches;
      });
  }
}
